// src/api.js
import axios from 'axios';
import Cookies from "js-cookie";


const token = Cookies.get("token");

const api = axios.create({
    baseURL: 'https://chat.cstmpanel.com/api', // Replace with your API URL
    // baseURL: 'http://localhost:5000/api', // Replace with your API URL
    headers: {
        'Authorization': "Bearer "+token, // Replace with your token
    },
});

export default api;